import styled from '@emotion/styled';
import { ModalContent } from '@vromo/ui/components/Modal';

export const CampaignModalContent = styled(ModalContent)`
    display: flex;
    flex-direction: row;
    width: 80vw;

    @media (max-width: 700px) {
        flex-direction: column;
    }
`;

export const TabPanelsWrapper = styled.div`
    padding: 30px;
`;

export const TabbedWrapper = styled.div`
    padding-top: 30px;
    flex: 1;
`;
